module.exports = __webpack_public_path__ + "static/binti-the-complete-trilogy-9d511081d203fc4f1c21a0f4a6266dfe.jpg";